import $$ from './axios-cms.service';
import signMd5Utils from '../../utils/sign.md5';
import { TIME_DIFFERENCE } from '../../store/types';


// get
export function getHttp(url, parameter) {
  const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'X-Sign': sign, 'X-TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'get',
    params: parameter,
    headers: signHeader
  });
}

export function postHttp(url, parameter) {
  const { sign } = parameter || {}
  // const sign = signMd5Utils.getSign(url, parameter);
  // 将签名和时间戳，添加在请求接口 Header
  const diff = window.sessionStorage.getItem(TIME_DIFFERENCE) || 0;
  const signHeader = { 'Sign': sign, 'TIMESTAMP': signMd5Utils.getDateTimeToStringDiff(diff) };

  return $$({
    url,
    method: 'post',
    data: parameter,
    headers: signHeader
  });
}
